export default {
      id: "oc-res-suggestsrule-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-suggestsrule",
      toString: function () {
        return this.url;
      }
    }